const NO_VALUE_TOKENS = new Set(['none', 'no', 'unknown', 'n/a']);

const normalizeFeatureValue = (value) => {
  const text = String(value ?? '').trim();
  if (!text) return null;
  if (NO_VALUE_TOKENS.has(text.toLowerCase())) return null;
  return text;
};

const appendFromList = (highlights, label, list, maxItems = 2, maxHighlights = 5) => {
  if (!Array.isArray(list)) return;
  const items = list
    .map((item) => normalizeFeatureValue(item))
    .filter(Boolean)
    .slice(0, maxItems);

  items.forEach((item) => {
    if (highlights.length < maxHighlights) {
      highlights.push(`${label}: ${item}`);
    }
  });
};

export const getTopFeatureHighlights = (mlsProfile, maxHighlights = 5) => {
  if (!mlsProfile || typeof mlsProfile !== 'object') return [];

  const highlights = [];
  const append = (label, value) => {
    if (highlights.length >= maxHighlights) return;
    const normalized = normalizeFeatureValue(value);
    if (!normalized) return;
    highlights.push(`${label}: ${normalized}`);
  };

  append('Type', mlsProfile.property_type);
  append('Pool', mlsProfile.pool);
  append('Garage', mlsProfile.garage_type);
  append('Heating', mlsProfile.heating_type);
  append('Cooling', mlsProfile.cooling_type);

  appendFromList(highlights, 'Outdoor', mlsProfile.exterior_features, 2, maxHighlights);
  appendFromList(highlights, 'Flooring', mlsProfile.flooring, 1, maxHighlights);
  appendFromList(highlights, 'Appliance', mlsProfile.appliances_included, 2, maxHighlights);
  appendFromList(highlights, 'Internet', mlsProfile.internet, 1, maxHighlights);

  return [...new Set(highlights)].slice(0, maxHighlights);
};
